import { render, staticRenderFns } from "./UsersTableComponent.vue?vue&type=template&id=97b4d1dc&scoped=true&"
import script from "./UsersTableComponent.vue?vue&type=script&lang=js&"
export * from "./UsersTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./UsersTableComponent.vue?vue&type=style&index=0&id=97b4d1dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b4d1dc",
  null
  
)

export default component.exports